import CompanyUserStatus from '../../domain/companies/CompanyUserStatus'
import { adminHttpClient } from '../commons/adminHttpClient'
import OrderedPageFilter from '../commons/orderedPageFilter'
import PagedList from '../commons/pagedList'

export type EmployeeResponse = {
  id: string
  firstName: string
  lastName: string
  workEmail: string
  employmentStatus: string
  employeeClass: string
  status: string
  createdAt: Date
  terminationDate: Date
  canBeInvited: boolean
  canBeReInvited: boolean
  benefitEligibilityDate?: Date
  canOptIn: boolean
  canOptOut: boolean
  username: string
  companyUserStatus: CompanyUserStatus
}

export type EmployeesFilter = OrderedPageFilter & { eligible: boolean; onlyTerminated: boolean }

const getEmployees = (filter: EmployeesFilter): Promise<PagedList<EmployeeResponse>> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'createdAt',
    orderDescending: true,
    eligible: true,
    onlyTerminated: false,
  }
  return adminHttpClient.get('/Companies/Employees', filter)
}

export default getEmployees
